module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/share-d87fea4443948e9eb925eb1a90a675bc.svg";